import { combineReducers } from "redux";
import createNamedWrapperReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/wrapperReducer";
import SubscriptionFeeReducer from "./subscriptionRate";
export default combineReducers({
    SubscriptionFee: createNamedWrapperReducer(SubscriptionFeeReducer, "SubscriptionFee"),
});
